module.exports = __webpack_public_path__ + "img/mastercard@2x.a8212b9.png";